export const base = {
  cover: "cover",
  contain: "contain",
}

export type Base = Record<keyof typeof base, string>
